import along from '@turf/along';
import getStraightLine from './getStraightLine';
import getLength from '@turf/length';

export default function getChunkedStraightLine(
    fromLngLat: mapboxgl.LngLat,
    toLngLat: mapboxgl.LngLat,
): GeoJSON.LineString {

    const geometry = getStraightLine(fromLngLat, toLngLat);
    const length = getLength({type: 'Feature', geometry, properties: {}}, {units: 'meters'});

    const interval = (length > 3000) ? Math.floor(length / 100) : 30;
    const vertices = [];

    for (
        let currentInterval = interval;
        currentInterval <= length;
        currentInterval += interval
    ) {
        vertices.push(along(geometry, currentInterval, {units: 'meters'}).geometry.coordinates);
    }

    return {
        type: 'LineString',
        coordinates: [geometry.coordinates[0], ...vertices, geometry.coordinates[1]]
    };
}
